var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"title has-text-centered is-4"},[_vm._v("Patreon Sync Logs")]),_c('sync-logs-list',{attrs:{"logs":_vm.patreonActions,"user":_vm.user,"loading":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }